import React from 'react'
import './HomeServices.scss'
import HomeServicesCard from './HomeServicesCard/HomeServicesCard'

/*
  Три услуги. Слайдера нет: на десктопе карточки видны все сразу, на
  мобиле это лента со снапом — как в блоке оборудования.
*/
const HomeServices = ({ homeServicesData }) => {
  return (
    <div className='homeServices_container' id='services'>
      <div className="homeServices_block">
        <h1>Услуги для дома</h1>
        <div className="homeServices_item">
          {homeServicesData?.map((e) => (
            <HomeServicesCard
              key={e.id}
              img={e.img}
              title={e.title}
              subTitle={e.subTitle}
              textBtn={e.textBtn}
            />
          ))}
        </div>
      </div>
    </div>
  )
}

export default HomeServices
